module.exports = __webpack_public_path__ + "assets/img/gar5-9.139c99d2.jpg";